import { NavigationTree } from '@wpp-open/core'

import { facadeApi } from 'api'
import { skipEmptyParams } from 'api/common/utils'

export const fetchNavigationTreeApi = ({ tenantId, parentId }: { tenantId: string; parentId?: string }) =>
  facadeApi.get<NavigationTree>(`/v3/tenants/${tenantId}/navigation-tree`, {
    params: skipEmptyParams({
      parentId,
    }),
  })
